import { action } from 'easy-peasy';
import { IActionSetMedicationDelivery } from '../types';

const setMedicationDelivery: IActionSetMedicationDelivery = action((state, payload) => {
  state.current = payload;
});

export default setMedicationDelivery;
